import React from 'react'
import './myprofileexperience.css';

const MyProfileExperience = ({ expdetails, handleExperienceDelete }) => {
    return (
        <div style={{ marginTop: '1.5rem' }}>
            {expdetails && expdetails.length > 0 ? (
                <div>
                    {expdetails.map((experience, index) => (
                        <div key={experience.experience_id}>
                            <div style={{ marginBottom: '1rem' }}>
                                <div>
                                    <span>{experience.title} <button className='expdelbtn' onClick={() => handleExperienceDelete(experience.experience_id)}><i className="fa-solid fa-trash"></i></button></span>
                                    <span style={{ float: 'right', fontWeight: '300' }}>
                                        {new Date(experience.start_date).toLocaleDateString()} - {experience.end_date ? new Date(experience.end_date).toLocaleDateString() : 'Present'}
                                    </span>
                                </div>
                                <p style={{ fontWeight: '300', margin: '0.5rem 0' }}>{experience.company}</p>
                                <p style={{ fontSize: '0.9rem', fontWeight: '300' }}>
                                    {experience.tasks}
                                </p>
                            </div>
                            {index !== expdetails.length - 1 && <hr style={{ marginBottom: '1rem', color: 'grey', height: '0.5px', backgroundColor: 'lightgrey', border: 'none' }} />}
                        </div>
                    ))}
                </div>
            ) : (
                <div>
                    <span>No Experience Added</span>
                </div>
            )}
        </div>
    )
}

export default MyProfileExperience;